

















import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import ProductItem from './ProductItem.vue';
import ProductListBehaviourMixin from '../mixins/ProductListBehaviourMixin.vue';
// noinspection TypeScriptCheckImport
import isotope from '@/components/VueIsotope.vue';
import imagesLoaded from 'vue-images-loaded';
import { ApiModel, CameraModel } from '@/models/Product';

@Component({
  components: { ProductItem, isotope },
  directives: { imagesLoaded },
})
export default class ProductList extends ProductListBehaviourMixin {
  @Prop() private id!: string;
  @Ref() private readonly isotope!: any;
  private isotopeOptions = {
    // itemSelector: '.grid-item',
    getSortData: {
      // order: (item: ApiModel) => {
      //   const search = this.myProducts.find(el => {
      //     return el.pk === item.pk;
      //   });
      //   if (search === undefined) {
      //     return 0;
      //   }
      //   // console.info(search.order, this.myProducts.map(p => p.order));
      //   return search.order;
      // },
      order: 'order',
    },
    layoutMode: 'fitRows',
    cellsByRow: {
      columnWidth: 100,
      rowHeight: this.MaxHeight,
    },
    originTop: false,
    transitionDuration: 150,
    sortBy: 'order',
  };

  public get myProducts(): ApiModel[] {
    return (this as any).products;
  }
  public get MaxHeight() {
    let result: number;
    if (this.myProducts.length === 0 || this.myProducts[0].type !== 'Camera') {
      result = 80;
    } else {
      result = (this.myProducts[0] as any).height + 15;
    }
    return result;
  }
}
